import phone from "../../store/modules/phone"

export const btnList = (lang) => {
  return [
    {
      // icon: ['fas', 'microphone-slash'],
      icon:'microphone-slash',
      label: lang.mute,
      // actIcon: ['fas', 'microphone'],
      actIcon:'microphone',
      actLabel: lang.unmute,
      key: "mute"
    },
    {
      // icon: ['fas', 'pause'],
      // icon: ['fa-solid', 'fa-circle-pause'],
      icon:'circle-pause',
      label: lang.hold_call,
      // actIcon: ['fas', 'play-circle'],
      actIcon:'play-circle',
      actLabel: lang.resume_call,
      key: "hold"
    },
    {
      // icon: ['fas', 'phone-volume'],
      // customized the transfer button
      // icon:'phone-transfer',
      icon: 'phone-transfer',
      label: lang.attended_transfer,
      key: "transfer"
    },
    // {
    //   icon: ['fas', 'plus'],
    //   label: lang.conference_call,
    //   actLabel: lang.cancel_conference,
    //   key: "addCall"
    // },
    // ==========================================
    // 修正日時: 2026-01-26
    // 修正内容: 三者通話・キーボードアイコンをFontAwesomeに統一
    //           - iconを'conference'から['fas','users']に変更（表示崩れ対応）
    // ==========================================
    {
      icon: 'conference',
      label: '三者通話',
      key: "addCall",
      disabled: true,
    },
    // {
    //   icon: ['fas', 'volume-high'],
    //   label: lang.device_settings,
    //   key: "speaker",
    //   disabled: true,
    // },
    // {
    //   icon: ['fas', 'video'],
    //   label: lang.camera,
    //   key: "video",
    //   disabled: true,
    // },
    // {
    //   icon: '',
    //   label: '',
    //   key: "video",
    //   disabled: true,
    // },
    {
      // icon: ['fa-solid', 'fa-gear'],
      icon:'phone-setting',
      label: "設定",
      key: "setting"
    },
    // {
    //   icon: ['fas', 'keyboard'],
    //   label: lang.send_dtmf,
    //   key: "keyboard"
    // },
    // {
    //   icon: ['fas', 'plus'],
    //   label: lang.conference_call,
    //   // actLabel: lang.cancel_conference,
    //   key: "addCall"
    // },
    // ==========================================
    // 修正日時: 2026-01-26
    // 修正内容: キーボードアイコンをFontAwesomeに統一
    //           - iconを'keyboard'から['fas','keyboard']に変更（表示崩れ対応）
    // ==========================================
    {
      // icon: ['fas', 'keyboard'],
      icon: 'keyboard',
      label: 'キーパッド',
      key: "keyboard"
    },
    {
      // icon: ['fas', 'phone'],
      icon:'phone',
      label: '通話開始',
      key: "startCall",
      disabled:true,
    },
    {
      // icon: ['fas', 'phone'],
      icon:'phone',
      label: "切電",
      key: "cancel",
    }
  ]
}
